export default "__VITE_ASSET__BTkeogyD__";